import { useEffect, useState } from "react";
import { LookstyLoader } from "./Loader";

type Props = React.ComponentProps<typeof LookstyLoader> & {
  show: boolean;
  delay?: number;
};

export const DelayedLookstyLoader = ({ show, delay = 450, ...loaderProps }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) {
      setVisible(false);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setVisible(true);
    }, delay);

    return () => window.clearTimeout(timeoutId);
  }, [show, delay]);

  if (!show || !visible) return null;

  return <LookstyLoader {...loaderProps} />;
};
